import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store";
import App from "./App";
import { SocketProvider } from "./SocketContext";
import { ToastContainer } from "react-toastify";
import { installAuthHttp } from "./api/authHttp";
import { hasMasterSession, persistedSessionKey, sessionKey } from "./utils/authSession";
import { resetUser } from "./store/features/loginUser";
import { resetAgentUser } from "./store/features/loginUserTenant";
import { clearSessionScopedState } from "./utils/clearSessionScopedState";

localStorage.removeItem("auth_token");
localStorage.removeItem("token");

installAuthHttp({
  isSignedIn: () => hasMasterSession(store.getState().loginToken),
  onSessionExpired: async () => {
    clearSessionScopedState();
    localStorage.removeItem("sessionId");
    store.dispatch(resetUser());
    store.dispatch(resetAgentUser());
    // Persist the signed-out state first, or the reload rehydrates the old user and loops.
    await persistor.flush();
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
  },
});

// Cookies are shared across tabs, so a new login elsewhere makes this tab's user and session stale.
// Reload before this tab sends the old ids with the new cookie, or re-persists the old user.
window.addEventListener("storage", (event) => {
  if (event.key !== "persist:root" || !event.newValue) return;
  const otherTabSession = persistedSessionKey(event.newValue);
  if (otherTabSession && otherTabSession !== sessionKey(store.getState().loginToken)) {
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    {/* Hold render until auth rehydrates (blank, not a loader) to avoid guest/login flash. */}
    <PersistGate loading={null} persistor={persistor}>
      <SocketProvider>
        <ToastContainer autoClose={3000} />
        <App />
      </SocketProvider>
    </PersistGate>
  </Provider>
);
